"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDashboardEventDispatch = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var react_1 = require("react");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var events_1 = require("../events");
var DashboardStoreProvider_1 = require("./DashboardStoreProvider");
var commands_1 = require("../commands");
/**
 * Convenience hook for dispatching Dashboard events.
 *
 * @returns function that you can use to dispatch Dashboard events
 * @alpha
 */
exports.useDashboardEventDispatch = function () {
    var dispatch = DashboardStoreProvider_1.useDashboardDispatch();
    return react_1.useCallback(function (eventBody) {
        ts_invariant_1.default(events_1.isDashboardEventOrCustomDashboardEvent(eventBody), "Unsupported event passed to useDashboardEventDispatch result.");
        var command = commands_1.triggerEvent(eventBody);
        dispatch(command);
    }, [dispatch]);
};
//# sourceMappingURL=useDashboardEventDispatch.js.map